import React, {useMemo} from 'react';
import {ArrowForward as ArrowForwardIcon} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {func, object} from 'prop-types';
import {useDropzone} from 'react-dropzone';

import ButtonBar from './ButtonBar.jsx';
import Dropzone from './DropZone.jsx';
import FileListItem from './FileListItem.jsx';
import {Content} from './Common.jsx';

export const UploadStep = ({
  groupedFiles = {},
  onAddFiles,
  onRemoveFile,
  onAddFeatures,
}) => {
  const groupedFilesKeys = useMemo(
    () => Object.keys(groupedFiles),
    [groupedFiles],
  );

  const files = useMemo(
    () => groupedFilesKeys.map(key => groupedFiles[key].files).flat(),
    [groupedFiles, groupedFilesKeys],
  );

  const onDropFiles = droppedFiles => {
    onAddFiles(
      droppedFiles.filter(
        file => !files.find(f => f.name === file.name), //don't allow dupe files
      ),
    );
  };

  const {open} = useDropzone({onDrop: onDropFiles});

  return (
    <>
      <Content>
        <Dropzone files={files} onDrop={onDropFiles}>
          {groupedFilesKeys.length > 0 && (
            <React.Fragment>
              <Box height="100%" width="100%" overflow="auto" padding={2}>
                {groupedFilesKeys.map(fileName => (
                  <FileListItem
                    key={fileName}
                    file={groupedFiles[fileName]}
                    onRemoveFile={() => {
                      onRemoveFile(fileName);
                    }}
                  />
                ))}
              </Box>
              <Box width="100%" textAlign="left">
                <Button variant="contained" sx={{marginTop: 2}} onClick={open}>
                  Add more files
                </Button>
              </Box>
            </React.Fragment>
          )}
        </Dropzone>
      </Content>
      <ButtonBar>
        <Button
          disabled={groupedFilesKeys.length === 0}
          endIcon={<ArrowForwardIcon />}
          variant="contained"
          color="primary"
          data-testid="continue-btn"
          onClick={() => {
            onAddFeatures();
          }}
        >
          Continue
        </Button>
      </ButtonBar>
    </>
  );
};

UploadStep.propTypes = {
  onAddFiles: func,
  onRemoveFile: func,
  onAddFeatures: func,
  groupedFiles: object,
};

export default UploadStep;
